<p *ngIf="!notas?.length" class="vazio">Nenhuma nota fiscal encontrada.</p>

<table *ngIf="exibidas.length">
  <thead>
    <tr><th>Nº NF</th><th>Emissão</th><th>Conta</th><th>Emitida para</th><th class="num">Valor</th><th></th></tr>
  </thead>
  <tbody>
    <tr *ngFor="let n of exibidas">
      <td class="forte">{{ n.nrNf || n.nrRps }}</td>
      <td>{{ n.dtEmissao }}</td>
      <td class="sub">{{ n.nrInternoConta }}</td>
      <td>
        <ng-container *ngIf="n.nmPacienteRelacionado; else emitida">
          {{ n.nmEmitidaPara || 'este paciente' }}
          <div class="sub">paciente: {{ n.nmPacienteRelacionado }}</div>
        </ng-container>
        <ng-template #emitida>{{ n.nmEmitidaPara || '—' }}</ng-template>
      </td>
      <td class="num">{{ n.vlTotalNota | brl }}</td>
      <td class="acoes"><button type="button" class="btn" [disabled]="!n.urlNfs" (click)="verNota(n)">Ver nota</button></td>
    </tr>
  </tbody>
</table>

<div *ngIf="qtAnteriores && !mostrarAnteriores" class="mais-wrap">
  <button type="button" class="chip" (click)="mostrarAnteriores = true">Ver mais ({{ qtAnteriores }} anteriores)</button>
</div>
